export const MAIN_HEADER_HEIGHT = 58;
export const VOLUME_LADDER_HEIGHT = 200;
export const BLOTTERS_MIN_HEIGHT = 40;
export const OMS_DIALOG_WIDTH = 300;
